class DelayedShippingNotice extends HTMLElement {
  connectedCallback() {
    this.skus = new Set(this.dataset.skus.split(','));

    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.cartData?.items) {
        this.updateVisibility(event.cartData.items);
      } else {
        this.refresh();
      }
    });
  }

  disconnectedCallback() {
    this.cartUpdateUnsubscriber?.();
  }

  refresh() {
    fetch('/cart.js')
      .then((r) => r.json())
      .then(({ items }) => this.updateVisibility(items));
  }

  updateVisibility(items) {
    const hasDelayedItem = items.some((item) => this.skus.has(item.sku));
    this.classList.toggle('delayed-shipping-notice--hidden', !hasDelayedItem);
  }
}

customElements.define('delayed-shipping-notice', DelayedShippingNotice);
